import type { ReactElement } from "react";
import type { GridTreeNode } from "@mui/x-data-grid-premium";

export const GroupedRowCell = (treeNodeConfig: GridTreeNode, Component: ReactElement): React.ReactNode | undefined =>
  treeNodeConfig.depth !== 0 && Component;
